<template>
  <div v-if="revConfirm && revConfirm.receiptDetail">
    <div class="rowSpace"></div>
    <b-table-simple>
      <b-thead>
        <b-tr>
          <b-td class="col-label">인원 수</b-td>
          <b-td class="col-value"
            >남 {{ revConfirm.receiptDetail.teamManCnt }}명 / 여 {{ revConfirm.receiptDetail.teamWomanCnt }}명</b-td
          >
        </b-tr>
        <b-tr v-show="revConfirm.receiptDetail._rentListCarts.length > 0">
          <b-td class="col-label">리무진카트</b-td>
          <b-td class="col-value"
            ><p v-for="(r, ii) in revConfirm.receiptDetail._rentListCarts" :key="ii">
              {{ revConfirm.receiptDetail.rentList[r._idx].menuName }} : {{ r.saleQty }} 개
            </p></b-td
          >
        </b-tr>
        <b-tr v-show="revConfirm.receiptDetail._rentListClub.length > 0">
          <b-td class="col-label">대여채</b-td>
          <b-td class="col-value"
            ><p v-for="(r, ii) in revConfirm.receiptDetail._rentListClub" :key="ii">
              [{{ revConfirm.receiptDetail.rentList[r._idx].sexId === 'M' ? '남' : '여' }}]
              {{ revConfirm.receiptDetail.rentList[r._idx].menuName }} : {{ r.saleQty }} 개
            </p></b-td
          >
        </b-tr>
        <b-tr v-show="revConfirm.receiptDetail._rentListShoes.length > 0">
          <b-td class="col-label">대여화</b-td>
          <b-td class="col-value"
            ><p v-for="(rrr, iii) in revConfirm.receiptDetail._rentListShoes" :key="iii">
              {{ revConfirm.receiptDetail.rentList[rrr._idx].menuName }} : {{ rrr.saleQty }} 개
            </p></b-td
          >
        </b-tr>
        <b-tr v-show="revConfirm.receiptDetail.remarks.length > 0">
          <b-td class="col-label">추가요청사항</b-td>
          <b-td class="col-value"
            ><p>{{ revConfirm.receiptDetail.remarks }}</p></b-td
          >
        </b-tr>
      </b-thead>
    </b-table-simple>

    <!--  <b-card>-->
    <!--    <b-row class="mb-2">-->
    <!--      <b-col sm="3" class="text-sm-right"><b>인원수:</b></b-col>-->
    <!--      <b-col class="text-sm-left"-->
    <!--        >남 {{ revConfirm.receiptDetail.teamManCnt }}명 / 여 {{ revConfirm.receiptDetail.teamWomanCnt }}명-->
    <!--      </b-col>-->
    <!--    </b-row>-->

    <!--    <b-row class="mb-2" v-if="revConfirm.receiptDetail._rentListClub.length > 0">-->
    <!--      <b-col sm="3" class="text-sm-right"><b>대여채:</b></b-col>-->
    <!--      <b-col class="text-sm-left">-->
    <!--        <p v-for="(r, ii) in revConfirm.receiptDetail._rentListClub" :key="ii">-->
    <!--          {{ revConfirm.receiptDetail.rentList[r._idx].menuName }} : {{ r.saleQty }} 개-->
    <!--        </p>-->
    <!--      </b-col>-->
    <!--    </b-row>-->

    <!--    <b-row class="mb-2" v-if="revConfirm.receiptDetail._rentListShoes.length > 0">-->
    <!--      <b-col sm="3" class="text-sm-right"><b>대여화:</b></b-col>-->
    <!--      <b-col class="text-sm-left">-->
    <!--        <p v-for="(rrr, iii) in revConfirm.receiptDetail._rentListShoes" :key="iii">-->
    <!--          {{ revConfirm.receiptDetail.rentList[rrr._idx].menuName }} : {{ rrr.saleQty }} 개-->
    <!--        </p>-->
    <!--      </b-col>-->
    <!--    </b-row>-->
    <!--    <b-row class="mb-2" v-if="revConfirm.receiptDetail.remarks.length > 0">-->
    <!--      <b-col sm="3" class="text-sm-right"><b>추가요청사항:</b></b-col>-->
    <!--      <b-col class="text-sm-left">-->
    <!--        <p>{{ revConfirm.receiptDetail.remarks }}</p>-->
    <!--      </b-col>-->
    <!--    </b-row>-->
    <!--  </b-card>-->
  </div>
</template>

<script>
export default {
  name: 'ReceiptSummaryDetail',
  props: {
    listType: String,
    revConfirm: Object,
  },
};
</script>

<style scoped lang="scss">
p {
  margin: 0px;
}
.table {
  line-height: 2.5rem;
  margin: 0px;
  //background-color: #f5f5f5;

  .col-label {
    width: 35%;
    height: 2.5rem;
    font-size: 0.9rem;
    font-weight: 600;
    //background-color: #f6f6f6;
    border-bottom: 1px solid #eeeeee;
  }
  .col-value {
    width: 65%;
    height: 2.5rem;
    font-size: 0.9rem;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;
  }
}
.rowSpace {
  height: 0.5rem;
}
</style>
